const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`b919cd8ab2db8e8e2a241471fe80e622c7d243e5dd165cedb47514af26f9ba20`, `b919cd8ab2db8e8e2a241471fe80e622c7d243e5dd165cedb47514af26f9ba20`, 1, 92), undefined, false, false, 1));
            }

            getTemplateName() {
                return `b919cd8ab2db8e8e2a241471fe80e622c7d243e5dd165cedb47514af26f9ba20`;
            }

            getSourceContext() {
                return new this.Source(``, `b919cd8ab2db8e8e2a241471fe80e622c7d243e5dd165cedb47514af26f9ba20`, ``);
            }
        }],
        [92, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/article-header/article-header.twig`, `b919cd8ab2db8e8e2a241471fe80e622c7d243e5dd165cedb47514af26f9ba20`, 1);

                this.blocks = new Map([
                    ['title', [this, 'block_title']],
                    ['meta', [this, 'block_meta']],
                    ['eyebrow', [this, 'block_eyebrow']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/article-header/article-header.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_title(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/heading/heading.twig`, new Map([[`level`,  -1], [`content`, `A Rather Long Headline So We Don’t Forget About Line Breaks`]]), false, false, 3));
                this.echo(`  `);
            }

            block_meta(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/author/author.twig`, new Map([[`authors`, new Map([[0, new Map([[`name`, `Buster Boo`], [`avatar`, `/media/avatar-buster-b.jpg`], [`link`, `#`]])]])], [`date`, `2022-03-28T12:00:00.000Z`]]), false, false, 9));
                this.echo(`  `);
            }

            block_eyebrow(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <h2 class="u-hidden-visually">Categories</h2>
    <ul class="o-list o-list--inline">
      <li>
        `);
                this.echo(this.include(context, this.source, `@cloudfour/components/badge/badge.twig`, new Map([[`label`, `CSS`], [`href`, `#`], [`rel`, `category`]]), false, false, 24));
                this.echo(`      </li>
      <li>
        `);
                this.echo(this.include(context, this.source, `@cloudfour/components/badge/badge.twig`, new Map([[`label`, `HTML`], [`href`, `#`], [`rel`, `category`]]), false, false, 31));
                this.echo(`      </li>
      <li>
        `);
                this.echo(this.include(context, this.source, `@cloudfour/components/badge/badge.twig`, new Map([[`label`, `Responsive Design`], [`href`, `#`], [`rel`, `category`]]), false, false, 38));
                this.echo(`      </li>
    </ul>
  `);
            }

            getTemplateName() {
                return `b919cd8ab2db8e8e2a241471fe80e622c7d243e5dd165cedb47514af26f9ba20`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `b919cd8ab2db8e8e2a241471fe80e622c7d243e5dd165cedb47514af26f9ba20`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'b919cd8ab2db8e8e2a241471fe80e622c7d243e5dd165cedb47514af26f9ba20');

let template = env.loadTemplate('b919cd8ab2db8e8e2a241471fe80e622c7d243e5dd165cedb47514af26f9ba20');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/objects/article-header/demo/example.twig", args: context }
     );
     return rendered;;
};